import { BeatLoader } from "react-spinners";

export default function Loading() {
  return (
    <div className="flex h-[700px] flex-col items-center justify-center text-white">
      <BeatLoader color="#FFF" size={24} margin={4} />
    </div>
  );
}
